import { Component, OnInit } from '@angular/core';
import { CustomTermsConditionsNotesService } from 'src/app/core/services/custom-terms-conditions-notes.service';
import { ICustomTermsAndConditionsNotes, CustomTermsAndConditionsNotes } from 'src/app/core/models';
import { AppNotifyService } from 'src/app/core/services/app-notify.service';
import { NotifyType } from 'src/app/core/enums/NotifyType';

@Component({
  selector: 'app-custom-terms-conditions-notes',
  templateUrl: './custom-terms-conditions-notes.component.html',
  styleUrls: ['./custom-terms-conditions-notes.component.scss']
})
export class CustomTermsConditionsNotesComponent implements OnInit {

  constructor(private CustomTermsConditionsNotesService: CustomTermsConditionsNotesService, private appNotify: AppNotifyService) { }

  ngOnInit() {
    this.getTermsConditions();
  }

  textValue = '';
  changeText = false;

  public getTermsConditions(): CustomTermsAndConditionsNotes {
    var result;
    this.CustomTermsConditionsNotesService.getTermsAndConditions().subscribe((response: Array<ICustomTermsAndConditionsNotes>) => {
      result = response.find(r=>r.customTermsAndConditionsId===1);
      if(result){
        this.textValue = result.description;
        this.changeText = false;
      }
    });
    return result;
  }

  public changeTextFunction() {
    this.changeText = true;
  }

  public save() {
    const obj: CustomTermsAndConditionsNotes = new CustomTermsAndConditionsNotes();
    obj.description = this.textValue;
    obj.udatedBy = "user";
    obj.customTermsAndConditionsId = 1;
    obj.featureName = "submittalPackage";
    if (this.changeText) {
      this.CustomTermsConditionsNotesService.saveTermsAndConditions(obj).subscribe();
      this.appNotify.notify(NotifyType.SUCCESS, "Terms and Conditions Updated Successfully");
      this.changeText = false;
    }
   
  }

  
}
